import React from 'react';
import { Home, TrendingUp, BarChart2, CalendarDays, Newspaper } from 'lucide-react';

// This object maps route names to their corresponding icons with consistent styling
export const NavigationIcons = {
  home: (isActive) => (
    <Home
      size={24}
      strokeWidth={2}
      color={isActive ? '#ffffff' : '#9ca3af'}
    />
  ),
  trending: (isActive) => (
    <TrendingUp
      size={24}
      strokeWidth={2}
      color={isActive ? '#ffffff' : '#9ca3af'}
    />
  ),
  boxoffice: (isActive) => (
    <BarChart2
      size={24}
      strokeWidth={2}
      color={isActive ? '#ffffff' : '#9ca3af'}
    />
  ),
  upcoming: (isActive) => (
    <CalendarDays
      size={24}
      strokeWidth={2}
      color={isActive ? '#ffffff' : '#9ca3af'}
    />
  ),
  news: (isActive) => (
    <Newspaper
      size={24}
      strokeWidth={2}
      color={isActive ? '#ffffff' : '#9ca3af'}
    />
  ),
};
